<template>
  <div
    class="shop-profile-desktop-cover main"
    :class="{ disappear: hidden }"
    @click="hide"
  >
    <div class="wrapper no-scrollbar" @touchmove="hide" v-on:scroll="hide">
      <div class="top-bar is-flex">
        <span style="flex-shrink: 1">
          <img class="profile-pic" :src="profilePicURL" />
        </span>
        <span class="header">{{ business.name }}</span>
        <span class="top-right">
          <span class="button" @click="gotoTab('menu')">{{
            $t("shop.menu")
          }}</span
          >&nbsp;
          <span class="button" @click="gotoTab('info')">{{
            $t("shop.info")
          }}</span>
        </span>
      </div>
      <div class="desktop" v-webp:bg="desktopBannerPicURL" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopProfileDesktopCover",
  components: {},
  props: {},
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
    desktopBannerPicURL() {
      return this.business.data.desktop_banner_pic_url;
    },
    profilePicURL() {
      return (
        this.business.profile_pic_url ||
        this.$store.state.menuItemPlaceholderPic
      );
    },
  },
  data() {
    return {
      hidden: false,
    };
  },
  methods: {
    hide() {
      //   this.hidden = true;
      this.$emit("close");
    },
    gotoTab(tab) {
      this.$emit("gotoTab", tab);
      this.hide();
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.wrapper {
  /* position: relative; */
  height: 101vh;
  padding-bottom: 51vh;
  /* margin-bottom: 300px; */
  overflow: auto;
}
.disappear {
  /* height: 0px; */
  top: -102vh;
  transition: all 1s ease;
}
.desktop {
  height: 600px;
  max-height: 50vh;
  background-size: cover;
  background-position: center;
  z-index: 2;
}
.top-bar {
  background-color: white;
  height: 60px;
  /* padding: 12px; */
  /* padding-left: 56px; */
  text-align: left;
  z-index: 99999;
}
.header {
  padding: 12px;
  padding-right: 0;
  font-size: 1.2em;
  font-weight: 500;
  margin-top: 4px;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.top-right {
  flex-shrink: 1;
  padding: 12px;
}
.profile-pic {
  /* position: absolute;
  top: 170px;
  left: max(calc((100vw - 900px) / 2), 14px);
  border-radius: 3px; */
  /* margin-left: -12px;
  margin-top: -12px; */
  object-fit: cover;
  height: 60px;
  width: 60px;
  /* box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4); */
  z-index: 2;
  transition: all 0.9s ease;
}
</style>